export default "__VITE_ASSET__CLOm0iWy__"